export default {
  order: {
    title: "Sipariş",
    pickupDate: "Alış tarihi",
    pickup: "Alış yeri",
    dropoff: "Varış yeri",
    passenger: "Yolcu",
    comment: "Yorum",
    vehicle: "Araç",
    chauffeur: "Şoför",
    passengersCount: "Yolcular",
    childSeats: "Çocuk koltukları",
    flightNumber: "Uçuş numarası",
    nameSign: "İsim tabelası",
    speaks: "Konuşuyor",
    call: "Ara",
    licensePlate: "Plaka",
    category: "Kategori",
    status: {
      new: "Onay bekleniyor",
      confirmed: "Sipariş onaylandı",
      on_my_way: "Yolda",
      at_the_location: "Yerde varış",
      pob: "Yolcu araçta",
      clear: "Sipariş tamamlandı",
      no_show: "Yolcu gelmedi",
      canceled: "Sipariş iptal edildi"
    },
    statusDescriptions: {
      new: "Sipariş tedarikçi onayı bekliyor",
      confirmed: "Tedarikçi siparişi onayladı, başlangıç bekleniyor",
      on_my_way: "Şoför alış yerine gidiyor",
      at_the_location: "Şoför geldi ve yolcuyu bekliyor",
      pob: "Yolcu bindi, varış yerine gidiyor",
      clear: "Sipariş başarıyla tamamlandı",
      no_show: "Yolcu alış yerinde görünmedi",
      canceled: "Sipariş iptal edildi"
    },
    messages: {
      noChauffeurAssigned: "Şoförünüz henüz atanmadı",
      detailsWillAppear: "Ayrıntılar atandıktan sonra burada görünecek",
      unknown: "Bilinmeyen",
      started: "Başladı",
      awaitingAssignment: "Atama bekleniyor"
    },
    childSeatsTypes: {
      child_01: "Bebek oto koltuğu (6 ay)",
      child_02: "Dönüştürülebilir koltuk (0-7 yaş)",
      child_03: "Yükseltici koltuk (6-12 yaş)"
    },
    distance: "{distance} km",
    review: "Yolculuğunuzu değerlendirin",
    review_status: {
      perfect: 'Mükemmel',
      good: 'İyi',
      average: 'Orta',
      bad: 'Kötü',
      terrible: 'Berbat'
    }
  },
  common: {
    save: "Kaydet",
    cancel: "İptal",
    loading: "Yükleniyor...",
    error: "Hata"
  }
}